import { useMemo } from 'react';

import { PharmindexIntegrationInfo, PharmindexIntegrationInfoQuery } from '@dreryk/medicine-database-pharmindex-api';

import {
   LazyLoadedDataConfigurationByCqrsQuery,
   useLazyLoadedDataConfigurationByCqrsQuery,
} from '@dreryk/drerykweb-main-frontend';
import { dateTimeFormatter, Ordering } from '@dreryk/react-common';
import { TableColumnConfiguration, ValueRendererProps } from '@dreryk/react-components';

import { integrationStatusFormatter } from '../translations';

import { PharmindexIntegrationDetailsCell } from './PharmindexIntegrationDetailsCell';

const ordering: Ordering<PharmindexIntegrationInfo>[] = [
   {
      property: 'startTime',
      descending: true,
   },
];

export const usePharmindexIntegrationStatusTableColumns = (): TableColumnConfiguration<PharmindexIntegrationInfo>[] => {
   return useMemo((): TableColumnConfiguration<PharmindexIntegrationInfo>[] => {
      return [
         {
            accessor: 'startTime',
            label: 'medicineDatabasePharmindex:integration.startTime',
            formatter: dateTimeFormatter,
            width: '25%',
         },
         {
            accessor: 'endTime',
            label: 'medicineDatabasePharmindex:integration.endTime',
            formatter: dateTimeFormatter,
            width: '25%',
         },
         {
            accessor: 'status',
            label: 'medicineDatabasePharmindex:integration.status',
            formatter: integrationStatusFormatter,
            width: '25%',
         },
         {
            accessor: 'warnings',
            label: 'medicineDatabasePharmindex:integration.warnings',
            sortingDisabled: true,

            renderer: ({ bean }: ValueRendererProps<PharmindexIntegrationInfo>) => (
               <PharmindexIntegrationDetailsCell
                  buttonLabel={'common:show'}
                  windowTitle={'medicineDatabasePharmindex:integration:warnings'}
                  content={bean.warnings}
               />
            ),

            width: '25%',
         },
      ];
   }, []);
};

export const usePharmindexIntegrationStatusTableDataConfiguration = (): LazyLoadedDataConfigurationByCqrsQuery<PharmindexIntegrationInfo> => {
   return useLazyLoadedDataConfigurationByCqrsQuery<PharmindexIntegrationInfo>(() => {
      return new PharmindexIntegrationInfoQuery();
   }, ordering);
};
